import Vue from 'vue'
import router from '@router'
import store from '@state/store'
import * as firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/firestore'
import 'firebase/auth'
import {
  MdApp,
  MdDrawer,
  MdDialog,
  MdDialogConfirm,
  MdDivider,
  MdSubheader,
  MdIcon,
  MdToolbar,
  MdList,
  MdField,
  MdRadio,
  MdButton,
  MdContent,
  MdTabs,
  MdMenu,
  MdDatepicker,
  MdChips,
  MdAutocomplete,
  MdCheckbox,
  MdTable,
  MdEmptyState,
  MdRipple,
  MdHighlightText,
} from 'vue-material/dist/components'
import App from './app.vue'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

// Globally register all `_base`-prefixed components
import '@components/_globals'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.use(MdApp)
Vue.use(MdDrawer)
Vue.use(MdDialog)
Vue.use(MdDialogConfirm)
Vue.use(MdDivider)
Vue.use(MdSubheader)
Vue.use(MdIcon)
Vue.use(MdToolbar)
Vue.use(MdList)
Vue.use(MdField)
Vue.use(MdRadio)
Vue.use(MdButton)
Vue.use(MdContent)
Vue.use(MdTabs)
Vue.use(MdMenu)
Vue.use(MdDatepicker)
Vue.use(MdChips)
Vue.use(MdAutocomplete)
Vue.use(MdCheckbox)
Vue.use(MdTable)
Vue.use(MdEmptyState)
Vue.use(MdRipple)
Vue.use(MdHighlightText)

var firebaseConfig = {
  apiKey: 'AIzaSyAtNCt9AumLS1OOkELikWnt0NxaetRnEAI',
  authDomain: 'qa-game-test.firebaseapp.com',
  projectId: 'qa-game-test',
  storageBucket: 'qa-game-test.appspot.com',
  messagingSenderId: '121414138950',
  appId: '1:121414138950:web:09dd1d83877bcbcdf8de47',
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)

const app = new Vue({
  router,
  store,
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      store.dispatch('qa/fetchUser', user)
    })
  },
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
